/**
 * Dependencies
 */
import React from 'react';
import { Route } from 'react-router';
import PropTypes from 'prop-types';

export const Status = ({ code }) => (
  <Route
    render={({ staticContext }) => {
      if (staticContext && code) {
        staticContext.statusCode = code;
      }

      return null;
    }}
  />
);

Status.propTypes = {
  code: PropTypes.number,
};

/**
 * 404 route handler.
 */
export const NotFound = ({ reason, source }) => (
  <Status code={reason && source && 404} reason={reason} source={source} />
);

NotFound.propTypes = {
  /** The reason for the 404 */
  reason: PropTypes.string.isRequired,
  /** Where the 404 is being used */
  source: PropTypes.string.isRequired,
};
